import { createStore } from 'vuex';

const parse = function(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}

const store = createStore({
  state: {
    selectedCard: localStorage.getItem('selectedCard') || '',
    currentUserNodeDetail: parse(localStorage.getItem('currentUserNodeDetail')) || null,
    cohortIds: parse(localStorage.getItem('cohortIds')) || [],
    currentUserNode: parse(localStorage.getItem('currentUserNode')) || null,
    isMultiSite: parse(localStorage.getItem('isMultiSite')) || false,
    scannedLoggerData: localStorage.getItem('scannedLoggerData') || '',
    scannedInverterData: localStorage.getItem('scannedInverterData') || '',
    // combinedData: parse(localStorage.getItem('combinedData')) || null
    combinedData: null 
  },
  mutations: {
    setSelectedCard(state, card) {
      state.selectedCard = card;
      localStorage.setItem('selectedCard', card);
    },
    setCurrentUserNodeDetail(state, nodeDetail) {
      state.currentUserNodeDetail = nodeDetail;
      localStorage.setItem('currentUserNodeDetail', JSON.stringify(nodeDetail));
    },
    setCohortIds(state, cohortIds) {
      state.cohortIds = cohortIds;
      localStorage.setItem('cohortIds', JSON.stringify(cohortIds));
    },
    setCurrentUserNode(state, nodeDetail) {
      state.currentUserNode = nodeDetail;
      localStorage.setItem('currentUserNode', JSON.stringify(nodeDetail));
    },
    setIsMultiSite(state, isMultiSite) {
      state.isMultiSite = isMultiSite;
      localStorage.setItem('isMultiSite', isMultiSite);
    },
    setLoggerData(state, data) {
      state.scannedLoggerData = data;
      localStorage.setItem('scannedLoggerData', data);
    },
    setInverterData(state, data) {
      state.scannedInverterData = data;
      localStorage.setItem('scannedInverterData', data);
    },
    setCombinedData(state, data) {
      state.combinedData = data;
      localStorage.setItem('combinedData', JSON.stringify(data));
    }
  },
  actions: {
    updateSelectedCard({ commit }, card) {
      commit('setSelectedCard', card);
    },
    updateCurrentUserNodeDetail({ commit }, nodeDetail) {
      commit('setCurrentUserNodeDetail', nodeDetail);
    },
    updateCohortIds({ commit }, cohortIds) {
      commit('setCohortIds', cohortIds);
    },
    updateCurrentUserNode({ commit }, nodeDetail) {
      commit('setCurrentUserNode', nodeDetail);
    },
    updateIsMultiSite({ commit }, isMultiSite) {
      commit('setIsMultiSite', isMultiSite);
    },
    saveLoggerData({ commit }, data) {
      commit('setLoggerData', data);
    },
    saveInverterData({ commit }, data) {
      commit('setInverterData', data);
    },
    saveCombinedData({ commit }, data) {
      commit('setCombinedData', data);
    }
  },
  getters: {
    selectedCard: (state) => state.selectedCard,
    currentUserNodeDetail: (state) => state.currentUserNodeDetail,
    cohortIds: (state) => state.cohortIds,
    currentUserNode: (state) => state.currentUserNode,
    isMultiSite: (state) => state.isMultiSite,
    getLoggerData: (state) => state.scannedLoggerData,
    getInverterData: (state) => state.scannedInverterData,
    getCombinedData: (state) => state.combinedData 

  }
});

export default store;